module.exports = __webpack_public_path__ + "static/media/company.06cdb10c.png";